export default {
  route: {
    discountDetail: 'Báo cáo chi tiết giảm giá',
    discountSummary: 'Báo cáo tổng hợp giảm giá',
    refundReport: 'Báo cáo hoàn tiền',
    syntheticFreeRoomReport: 'Báo cáo tổng hợp miễn phí',
    roomSchedule: 'Kế hoạch đặt phòng',
    notificationConfig: 'Thông báo',
    config: 'Cấu hình',
    general: 'Chung',
    hotel: 'Khách sạn',
    // 'warehousePurchaseOrder': '',
    servicesPoliciesPrices: 'Dịch vụ, chính sách & giá bán',
    accounting: 'Kế toán',
    profile: 'Hồ sơ',
    userConfiguration: 'Cấu hình người dùng',
    connectionConfig: 'Cấu hình kết nối',
    log: 'Nhật ký',
    display: 'Hiển thị',
    configTemplate: 'Cấu hình mẫu',
    guestProfileNoticeTemplate: 'Mẫu ghi chú hồ sơ khách',
    parameters: 'Tham số',
    room: 'Phòng',
    statistic: 'Thống kê',
    groupUser: 'Nhóm người dùng',
    user: 'Người dùng',
    department: 'Bộ phận',
    authorization: 'Phân quyền',
    permission: 'Phân quyền',
    companyTravelAgentProfile: 'Hồ sơ công ty, đại lý du lịch',
    guestProfile: 'Hồ sơ khách',
    companyProfileForInvoicing: 'Hồ sơ công ty xuất hóa đơn',
    systemLog: 'Nhật ký hệ thống',
    connectLog: 'Nhật ký kết nối',
    syncDataLog: 'Nhật ký đồng bộ dữ liệu',
    lateCheckoutEarlyCheckIn: 'Nhận phòng sớm, trả phòng muộn',
    cancelNoShow: 'Hủy/Không đến',
    packageCategory: 'Danh mục gói',
    packageGroup: 'Nhóm gói',
    package: 'Gói',
    packageLog: 'Nhật ký gói',
    rateCategory: 'Danh mục giá',
    rateCode: 'Mã giá',
    dailyRoomRate: 'Giá phòng theo ngày',
    roomSurcharge: 'Phụ thu phòng',
    breakfast: 'Ăn sáng',
    specialService: 'Dịch vụ đặc biệt',
    housekeepingServiceGroup: 'Nhóm dịch vụ buồng phòng',
    group: 'Đoàn',
    newGroupMaster: 'Tạo đoàn mới',
    // searchGroupMaster: 'Tìm kiếm đoàn',
    searchGroupMaster: 'Đoàn master',
    groupTransaction: 'Giao dịch đoàn',
    groupLog: 'Nhật ký đoàn',
    groupTracing: 'Đoàn cần theo dõi',
    hk: 'Buồng',
    taskAssignment: 'Phân lịch dọn phòng',
    roomCondition: 'Tình trạng buồng phòng',
    hotelStatus: 'Trạng thái khách sạn',
    housekeepingService: 'Dịch vụ buồng phòng',
    lostFound: 'Đồ thất lạc',
    outOfOrderOutOfService: 'Phòng ngừng sử dụng, phòng không phục vụ',
    requestManagement: 'Quản lý yêu cầu',
    maintainJobProcessing: 'Xử lý và tiếp nhận yêu cầu',
    maintenanceConfig: 'Cấu hình bảo trì',
    maintenanceLocation: 'Vị trí bảo trì',
    jobType: 'Loại việc',
    businessArea: 'Khu kinh doanh',
    areaMap: 'Sơ đồ khu kinh doanh',
    invoicesList: 'Danh sách hóa đơn khu kinh doanh',
    splitTableRoom: 'Tách bàn/phòng',
    audit: 'Kiểm toán',
    shiftClosureSummary: 'Tổng hợp cuối ca',
    breakfastReal: 'Bữa ăn sáng thực tế',
    inHouseGuest: 'Khách đang ở',
    businessAreaLog: 'Nhật ký khu kinh doanh',
    warehouse: 'Kho',
    po: 'Mua hàng',
    ar: 'Công nợ',
    warehousePurchaseOrder: 'Kho, mua hàng',
    supplier: 'Nhà cung cấp',
    receiver: 'Bộ phận nhận',
    openingStock: 'Tồn kho đầu kỳ',
    product: 'Sản phẩm',
    subTransactionType: 'Loại giao dịch phụ',
    transaction: 'Giao dịch',
    payment: 'Thanh toán',
    deposit: 'Đặt cọc',
    refund: 'Hoàn tiền',
    assignTransactionsToServicesProducts: 'Gán giao dịch vào dịch vụ, sản phẩm',
    bankCard: 'Tài khoản ngân hàng',
    serviceCharge: 'Phí dịch vụ',
    tax: 'Thuế',
    autoCode: 'Mã tự động',
    globalParameter: 'Cấu hình tham số chung',
    building: 'Tòa nhà',
    roomAttribute: 'Thuộc tính phòng',
    roomType: 'Hạng phòng',
    outOfOrderOutOfServiceReason: 'Lý do ngừng sử dụng/không phục vụ',
    roomMap: 'Sơ đồ phòng',
    reservationFrontDesk: 'Đặt phòng/lễ tân',
    cashiering: 'Thu ngân',
    sourceGroup: 'Nhóm nguồn',
    source: 'Nguồn',
    marketSegmentGroup: 'Nhóm phân khúc thị trường',
    marketSegment: 'Phân khúc thị trường',
    marketBusiness: 'Phân khúc kinh doanh',
    language: 'Ngôn ngữ',
    vip: 'VIP',
    promotion: 'Khuyến mại',
    currency: 'Tiền tệ',
    systemLogs: 'Nhật ký hệ thống',
    accessConfig: 'Cấu hình truy cập',
    accessApproval: 'Phê duyệt truy cập',
    importInvoice: 'Phiếu nhập',
    exportInvoice: 'Phiếu xất',
    stockTransferInvoice: 'Phiếu điều chuyển',
    inventoryInvoice: 'Phiếu kiểm kê',
    adjustWarehouseInvoice: 'Điều chỉnh hóa đơn kho',
    stockCard: 'Thẻ kho',
    processConsumables: 'Xử lý hàng tiêu thụ',
    purchaseRequest: 'Phiếu đề xuất mua hàng',
    purchaseOrder: 'Đơn đặt hàng',
    purchaseInvoice: 'Hóa đơn mua hàng',
    handoverVoucherList: 'Phiếu bàn giao',
    supplierQuotation: 'Báo giá nhà cung cấp',
    accountReceivable: 'Tài khoản công nợ',
    postPayment: 'Thêm thanh toán',
    searchVoucher: 'Tìm voucher',
    getFromFrontDesk: 'Nhận từ lễ tân',
    overdueCharge: 'Phí quá hạn',
    voucherType: 'Loại voucher',
    arStatement: 'Bảng kê công nợ',
    report: 'Báo cáo',
    other: 'Khác',
    cmsEzCrs: 'CMS/EZCRS',
    mappingRoomType: 'Ghép hạng phòng',
    updateInventory: 'Cập nhật kho phòng',
    updatePrice: 'Cập nhật giá',
    rateMapping: 'Ghép chính sách',
    stopSell: 'Ngừng bán',
    mappingPaymentMethod: 'Ghép phương thức thanh toán',
    cancellationTransactionConfig: 'Cấu hình giao dịch hủy đặt phòng',
    mappingCompanyTravelAgentOnline: 'Ghép công ty, đại lý du lịch trực tuyến',
    notificationEmail: 'Thư thông báo',
    configureEmailTemplates: 'Cấu hình email mẫu',
    vipAdmin: 'Vip Admin',
    vipCard: 'Thẻ Vip',
    vipConfig: 'Cấu hình Vip',
    vipMember: 'Số vip',
    logVipCard: 'Lịch sử thẻ Vip',
    reservation: 'Đặt phòng',
    newReservation: 'Tạo đặt phòng',
    searchReservation: 'Tìm kiếm đặt phòng',
    roomAssignment: 'Gán phòng',
    reservationStatus: 'Trạng thái đặt phòng',
    folioLog: 'Nhật ký',
    roomAvailability: 'Tình trạng phòng trống',
    allotmentContract: 'Hợp đồng Allotment',
    reservationFromCmsEzCrs: 'Đặt phòng từ CMS/EZCRS',
    tasksList: 'Danh sách nhiệm vụ',
    frontDesk: 'Lễ tân',
    arrivalGuest: 'Khách đến',
    assignRoom: 'Gán phòng',
    birthday: 'Sinh nhật',
    roomStatusByHskp: 'Trạng thái buồng phòng',
    exportPoliceReport: 'Xuất báo cáo công an',
    cashier: 'Thu ngân',
    cashierClosure: 'Đóng thu ngân',
    groupCheckout: 'Trả phòng đoàn',
    cancelNoShowCharge: 'Phí hủy/Không đến',
    postToDummyRooms: 'Thêm giao dịch vào phòng ảo',
    cashierClosureReport: 'Báo cáo Đóng Thu ngân',
    ezInvoice: 'EZINVOICE - Hóa đơn điện tử',
    incurredTransactionList: 'Danh sách giao dịch phát sinh',
    addEInvoice: 'Thêm hóa đơn',
    eInvoicesList: 'Danh sách hóa đơn điện tử',
    displayInvoiceDetailsConfiguration: 'Cấu hình hiển thị chi tiết hóa đơn',
    serialInvoiceList: 'Danh sách ký hiệu hóa đơn',
    serialInvoicePermission: 'Phân quyền ký hiệu hóa đơn',
    serialInvoiceForPointOfSaleConfiguration:
      'Cấu hình ký hiệu hóa đơn cho điểm bán hàng',
    parameter: 'Tham số',
    location: 'Vị trí',
    roomTable: 'Phòng/bàn',
    shift: 'Ca',
    printer: 'Máy in',
    hotline: 'Tổng đài',
    smartLock: 'Khóa từ',
    issueStaffCard: 'Cắt khóa cho nhân viên',
    keyManagement: 'Cấu hình khóa phòng',
    iptv: 'IPTV',
    hotel_link_config: 'Cấu hình Hotel Link',
    hotel_link_dashboard: 'Dashboard Hotel Link',
    productCategory: 'Danh mục sản phẩm',
    serviceType: 'Loại sản phẩm/dịch vụ',
    attributeCategory: 'Danh mục thuộc tính',
    attribute: 'Thuộc tính',
    unit: 'Đơn vị tính',
    materialQuantification: 'Khai báo định lượng',
    utility: 'Lối tắt',
    homePage: 'Trang chủ',
    availability: 'Tình trạng phòng trống',
    roomPlan: 'Kế hoạch sử dụng phòng',
    reservationReport: 'Báo cáo đặt phòng',
    historyandForecastReport: 'Báo cáo lịch sử và dự kiến theo hạng phòng',
    historyReport: 'Báo cáo lịch sử',
    foreCastReport: 'Báo cáo dự báo',
    salesEmployeeReport: 'Báo cáo nhân viên bán hàng',
    revenueBookingReport: 'Báo cáo doanh thu đặt phòng theo hạng phòng',
    revenueBookingDailyReport: 'Báo cáo doanh thu đặt phòng theo ngày',
    revenueBookingWeekyReport: 'Báo cáo dự báo đặt phòng theo tuần',
    historyForecastbyRoomLevelReport: 'Báo cáo lịch sử dự báo theo hạng phòng',
    freeRoomReport: 'Báo cáo chi tiết phòng miễn phí',
    arrivalGuestReport: 'Báo cáo khách đến',
    checkoutReport: 'Báo cáo checkout',
    dailyReport: 'Báo cáo hoạt động hàng ngày',
    discountBookingReport: 'Báo cáo giảm giá đặt phòng',
    breakFastReport: 'Báo cáo ăn sáng',
    cancelGuestReport: 'Báo cáo khách hủy',
    takeMoneybyInvoiceReport: 'Báo cáo thu tiền theo hóa đơn',
    syntheticDailyReport: 'Báo cáo tổng hợp giao dịch theo ngày',
    cancelTransactionReport: 'Báo cáo hủy giao dịch',
    depositDailyReport: 'Báo cáo đặt cọc theo ngày',
    miniBarReport: 'Báo cáo minibar',
    roomStatusDailyReport: 'Báo cáo tình trạng phòng và dịch vụ đặc biệt',
    equipmentReport: 'Báo cáo trang thiết bị',
    generalManageReport: 'Báo cáo quản lý chung',
    chartBySourceGroupReport: 'Báo cáo biểu đồ theo nhóm nguồn',
    revenueByAgencyReport: 'Báo cáo doanh thu theo đại lý',
    expectedReport: 'Báo cáo dự kiến',
    fillRateReport: 'Báo cáo tỉ lệ lấp đầy',
    fillRatebyMonthReport: 'Báo cáo tỉ lệ lấy đầy theo tháng',
    arriveGuestReport: 'Báo cáo khách đi',
    createSmartKeyReport: 'Báo cáo tạo khóa từ',
    cardOfGuestReport: 'Báo cáo sử dụng thẻ của khách',
    cardInternalReport: 'Báo cáo sử dụng thẻ Nội bộ',
    livingGuestReport: 'Báo cáo khách đang ở',
    walkinsGuestReport: 'Báo cáo khách walkins',
    bonusTransactionReport: 'Báo cáo chi tiết theo đặt phòng',
    paymentReport: 'Báo cáo thanh toán',
    groupGuestReport: 'Báo cáo khách đoàn',
    detailBookingReport: 'Báo cáo chi tiết đặt phòng',
    houseKeeperReport: 'Báo cáo buồng phòng',
    diaryChangeStatusRoomReport: 'Báo cáo nhật ký thay đổi trạng thái phòng',
    syntheticHKServiceReport: 'Báo cáo tổng hợp giao dịch buồng phòng',
    oooReport: 'Báo cáo phòng OOO/OOS',
    hkCheckReport: 'Báo cáo buồng phòng cần kiểm tra',
    lostReport: 'Báo cáo đồ thất lạc',
    invoiceAdjustReport: 'Báo cáo điều chỉnh giao dịch',
    invoiceCancelReport: 'Báo cáo hủy hóa đơn',
    syntheticTransactionReport: 'Báo cáo hình thức thanh toán theo hóa đơn',
    detailRevenueBookingReport:
      'Báo cáo chi tiết doanh thu đặt phòng và dịch vụ theo nhân viên',
    cashReport: 'Báo cáo tiền mặt',
    compareRevueneBookingReport: 'Báo cáo đối chiếu doanh thu kế toán',
    syntheticRevenueReport: 'Báo cáo tổng hợp doanh thu phòng',
    detailRevenueReport: 'Báo cáo doanh thu chi tiết',
    capacityChartReport: 'Báo cáo biểu đồ công suất phòng',
    salesReport: 'Báo cáo Sales/ Maketting',
    voucherReport: 'Báo cáo sử dụng voucher',
    promotionReport: 'Báo cáo doanh thu theo chương trình',
    advertiseReport: 'Báo cáo doanh thu từ quảng cáo',
    eventReport: 'Báo cáo doanh thu theo sự kiện',
    syntheticDebtReport: 'Báo cáo tổng hợp công nợ',
    detailDebtReport: 'Báo cáo chi tiết công nợ',
    invoiceReport: 'Báo cáo hóa đơn',
    compareRevenueRoomReport: 'Báo cáo biểu đồ so sánh doanh thu phòng',
    dateCancelKeepRoomReport: 'Bào cáo ngày hủy giữ phòng đoàn',
    diaryChangeGroupReport: 'Báo cáo nhật ký thay đổi đoàn',
    promotionsSystem: 'Hệ thống khuyến mại',
    dailyTransactionSynthesisReport: 'Báo cáo tổng hợp giao dịch theo ngày',
    groupReport: 'Báo cáo đoàn',
    itReport: 'Báo cáo IT',
    receptionReport: 'Báo cáo lễ tân',
    cfoReport: 'Báo cáo CFO',
    hkReport: 'Báo cáo buồng phòng',
    accoutingReport: 'Báo cáo kế toán',
    cashierReport: 'Báo cáo thu ngân',
    laundryReport: 'Báo cáo giặt là',
    directorReport: 'Báo cáo giám đốc',
    roomReport: 'Báo cáo phòng',
    houseKeepReport: 'Báo cáo buồng',
    analysisReport: 'Báo cáo phân tích',
    compensationReport: 'Báo cáo đền bù',
    agentWallet: 'Theo dõi tiền nạp đại lý',
    accountCashList: 'Kiểm kê tiền mặt',
    stayComboReport: 'Báo cáo combo lưu trú',
    reasonCancel: 'Lý do hủy phòng',
    agencyDetailReport: 'Báo cáo chi tiết đại lý',
    limitReport: 'Báo cáo hạn mức',
    hotelLinkReport: 'Báo cáo đặt phòng OTA',
    roomSalesQuantityInWebsite: 'Số lượng phòng được phép bán trên website',
    hotelLink: 'Hotel Link',
    hotelLinkConfig: 'Cấu hình',
    hotelLinkDashboard: 'Dashboard'
  }
}
